module.exports = __webpack_public_path__ + "media/images/icons/add-document-outline-49936ee3a74dc87864d47cd7b34cf03c.svg";